import React from 'react'
import Rollers from './shades/Rollers'
import ZebraShades from './shades/ZebraShades'
import CellularShades from './shades/CellularShades'
import RomanShades from './shades/RomanShades'
// import Curtains from './shades/Curtains'
import Vertical from './shades/Vertical'

const Catalogs = () => {
  return <>
    <Rollers />
    <ZebraShades />
    <CellularShades />
    <RomanShades />
    <Vertical />
    {/* <Curtains /> */}
  </>
}

export default Catalogs
